import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AlertasService {

  constructor(private alertas: AlertController) { }

  async mostrarMensajeSimple(encabezado:string, mensaje:string) {
    const alert = await this.alertas.create({
      header: encabezado,
      backdropDismiss: false,
      subHeader: '',
      message: mensaje,
      buttons: ['Entendido']
    });

    await alert.present();
  }

  async mostrarMensajeConfirmacion(encabezado:string, mensaje:string) {
    const alert = await this.alertas.create({
      header: encabezado,
      backdropDismiss: false,
      message: mensaje,
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancelar',
          handler: () => {
            console.log('cancelar');
          }
        }, {
          text: 'Aceptar',
          role: 'aceptar',
          handler: () => {
            console.log('aceptar');
          }
        }
      ]
    });
    return alert;
  }

}
